import axios from "axios";

export const verifyTokenAPI = async (token) => {
  return await axios.get(`${process.env.REACT_APP_BACKEND_URL}/verifyToken`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const userLoginAPI = async (payload) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/userLogin`, { payload });
        return response;
    } catch (error) {
        console.log('API Error:', error);
        if (error.response) {
            console.log('Response Error:', error.response.data);
            return { status: error.response.status, message: error.response.data.message || 'Unknown error occurred' };
        }
    }
};


export const userOtpVerifyAPI = async (params) => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/otpVerify?email=${params?.email}&otp=${params?.otp}`);
        return response;
    } catch (error) {
        console.log('API Error:', error);
        if (error.response) {
            console.log('Response Error:', error.response.data);
            return { status: error.response.status, message: error.response.data.message || 'Unknown error occurred' };
        }
    }
}


export const resendOtpAPI = async (email) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/otpRequest?email=${email}`);
    return response;
  } catch (error) {
    console.error('Resend OTP Error:', error);
    if (error.response) {
      return { status: error.response.status, message: error.response.data.message };
    }
  }
};

export const userSignupAPI = async (formData) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/signup`,
      formData, 
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response;
  } catch (error) {
    console.log('API Error:', error);
    if (error.response) {
      console.log('Response Error:', error.response.data);
      return {
        status: error.response.status,
        message: error.response.data.message || 'Unknown error occurred',
      };
    }
  }
};


export const userVerifyEmailAPI = async (payload) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/resendOtpRequest`, {...payload});
        return response;
    } catch (error) {
        console.log('API Error:', error);
        if (error.response) {
            console.log('Response Error:', error.response.data);
            return { status: error.response.status, message: error.response.data.message || 'Unknown error occurred' };
        }
    }
}

export const getCoursesDetailsAPI = async (payload) => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/courseDetails?page=${payload.page}&limit=${payload.limit}&email=${payload.email}&subjectName=${payload.subjectName}`);
        return response;
    } catch (error) {
        console.log('API Error:', error);
        if (error.response) {
            console.log('Response Error:', error.response.data);
            return { status: error.response.status, message: error.response.data.message || 'Unknown error occurred' };
        }
    }
}

export const addCourseAPI = async (formData) => {
    try {
        const response = await axios.post(
            `${process.env.REACT_APP_BACKEND_URL}/uploadFile`,
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }
        );
        return response;
    } catch (error) {
        console.log("API Error:", error);
        if (error.response) {
            console.log("Response Error:", error.response.data);
            return {
                status: error.response.status,
                message: error.response.data.message || "Unknown error occurred",
            };
        }
    }
};

export const getStudentResultsAPI = async ({ email, search = '', page = 1, limit = 5 }) => {
    try {
        const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/studentQuizDetails`, {
            params: {
                teacherEmail: email,
                searchTerm: search,
                page,
                limit,
            },
        });

        const quizResults = res?.data.quizResults || [];

        const tableData = quizResults?.map((item, index) => {
            const result = item.quizResults?.result || {};
            const percent = parseFloat(result.percentage || 0)
            return {
                key: index,
                email: item.email,
                course: item.quizResults?.subject || 'N/A',
                quizTaken: item.quizResults?.chapterName || 'N/A',
                marks: result.correctAnswers || 0,
                totalQuestions: result.totalQuestions || 0,
                percentage: result.percentage || '0',
                status: percent >= 70 ? 'Pass' 
                : percent >= 33 && percent < 70 ? 'Need Improvment' : 
                 'Fail',
            };
        });

        return {
            data: tableData,
            currentPage: res.data.currentPage,
            totalResults: res.data.totalResults || quizResults.length,
        };
    } catch (error) {
        console.error('Error fetching quiz results:', error);
        throw error;
    }
};

export const getAllStudentResultsAPI = async ({ search = '', page = 1, limit = 5 }) => {
  console.log("calling api all results api ......")
    try {
        const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/allResults`, {
            params: {
                searchTerm: search,
                page,
                limit,
            },
        });

        const quizResults = res?.data.quizResults || [];

        const tableData = quizResults?.map((item, index) => {
            const result = item.quizResults?.result || {};
            const percent = parseFloat(result.percentage || 0)
            return {
                key: index,
                email: item.email,
                course: item.quizResults?.subject || 'N/A',
                quizTaken: item.quizResults?.chapterName || 'N/A',
                marks: result.correctAnswers || 0,
                totalQuestions: result.totalQuestions || 0,
                percentage: result.percentage || '0',
                status: percent >= 70 ? 'Pass' 
                : percent >= 33 && percent < 70 ? 'Need Improvment' : 
                 'Fail',
            };
        });

        return {
            data: tableData,
            currentPage: res.data.currentPage,
            totalResults: res.data.totalResults || quizResults.length,
        };
    } catch (error) {
        console.error('Error fetching quiz results:', error);
        throw error;
    }
};


export const getCoursesForStudentsAPI = async (payload) => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/getTeacherCourses`, {
            params: {...payload},
        });
        return response.data;
    } catch (error) {
        console.log('API Error:', error);
        if (error.response) {
            console.log('Response Error:', error.response.data);
            return { status: error.response.status, message: error.response.data.message || 'Unknown error occurred' };
        }
    }
};


export const enrollCourseAPI = async (payload) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/enrollCourse`, {...payload});
        return response;
    } catch (error) {
        console.log('API Error:', error);
        if (error.response) {
            console.log('Response Error:', error.response.data);
            return { status: error.response.status, message: error.response.data.message || 'Unknown error occurred' };
        }
    }
};

export const getEnrolledCoursesAPI = async (email) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/getEnrollCourses`, {
      params: { email },
    });
    return response.data.enrolledCourses || [];
  } catch (error) {
    console.error('Error fetching enrolled courses:', error);
    return [];
  }
};

export const getSubjectLecturesAPI = async (payload) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/getSubjectLectures`, {
      params: { ...payload },
    });
    return response || [];
  } catch (error) {
    console.error('Error fetching enrolled courses:', error);
    return [];
  }
};

export const quizMcqsAPI = async (payload) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/startQuiz`, {...payload});
    return response || [];
  } catch (error) {
    console.error('Error fetching enrolled courses:', error);
    return [];
  }
};

export const submitQuizAPI = async (payload) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/submitQuiz`, {...payload});
    return response || [];
  } catch (error) {
    console.error('Error fetching enrolled courses:', error);
    return [];
  }
};

export const viewChapterReportAPI = async (payload) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/viewChapterReport`, {
      params: { ...payload },
    });
    return response || [];
  } catch (error) {
    console.error('Error fetching enrolled courses:', error);
    return [];
  }
};

export const getSingleStudentResultAPI = async ({ email, search = '', page = 1, limit = 5 }) => {
    try {
        const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/viewResults`, {
            params: {
                email,            
                searchTerm: search, 
                page,
                limit,
            },
        });

        const quizResults = res?.data.quizResults || [];

        const tableData = quizResults?.map((item, index) => {
            const result = item.quizResults?.result || {};
            const percent = parseFloat(result.percentage || 0)
            return {
                key: index,
                email: item.quizResults?.teacherEmail,
                course: item.quizResults?.subject || 'N/A',
                quizTaken: item.quizResults?.chapterName || 'N/A',
                marks: result.correctAnswers || 0,
                totalQuestions: result.totalQuestions || 0,
                percentage: result.percentage || '0',
                status: percent >= 70 ? 'Pass' 
                : percent >= 33 && percent < 70 ? 'Need Improvment' : 
                 'Fail',
            };
        });

        return {
            data: tableData,
            currentPage: res.data.currentPage,
            totalResults: res.data.totalResults || quizResults.length,
        };
    } catch (error) {
        console.error('Error fetching quiz results:', error);
        throw error;
    }
};

export const getStudentDashboardAPI = async (payload) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/getStudentDashboard`, {
      params: { ...payload },
    });
    return response || [];
  } catch (error) {
    console.error('Error fetching enrolled courses:', error);
    return [];
  }
};

export const getChildsAPI = async (payload) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/getChilds?email=${payload}`);
    return response || [];
  } catch (error) {
    console.error('Error fetching childs', error);
    return [];
  }
};

export const checkClassPromotionAPI = async (email) => {
  try {
    const { data } = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/promoteToNewClass?email=${email}`);
    return {
      success: true,
      allowGradeSelect: data?.allowGradeSelect,
      serverMessage: data?.message,
    };
  } catch (error) {
    console.error('Error in checkClassPromotion API:', error);
    return {
      success: false,
      allowGradeSelect: false,
      serverMessage: 'Error checking promotion eligibility.',
    };
  }
};


export const googleLoginAPI = async (credential) => {
  try {
    const res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/googleSign`, { token: credential });
    return res.data;
  } catch (err) {
    throw new Error(err.response?.data?.message || "Google Login failed");
  }
};

export const updateUserProfileAPI = async (formData, userId) => {
  try {
    const response = await axios.put(`${process.env.REACT_APP_BACKEND_URL}/editProfile/${userId}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Error updating profile');
  }
}








export const fetchConversationsAPI = async (email) => {
  const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/conversations/${email}`);
  return response.data;
};

export const startNewChatAPI = async (senderEmail, receiverEmail) => {
  const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/start`, {
    senderEmail,
    receiverEmail,
  });
  return response.data;
};

export const fetchMessagesAPI = async (chatId) => {
  const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/${chatId}`);
  return response.data.messages;
};

export const sendMessageAPI = async (chatId, message) => {
  await axios.post(`${process.env.REACT_APP_BACKEND_URL}/${chatId}/message`, message);
};